(function () {
  'use strict';

  var STORAGE_KEY = 'vw-byob-cart';
  var DISCOUNT_CODE = 'BUNDLE10';
  var DISCOUNT_PCT = 0.05;
  // Piece prices include UK postage (free UK delivery on every order), so a
  // 10-piece build (5% off via BUNDLE10) costs the same as the matching
  // pre-built Bundle of 10. Keep price_cents below in step with the Shopify
  // product prices.

  var VARIANTS = {
    wax_jacket:                { variant_id: 59185527357772, price_cents: 1145 },
    windbreaker:               { variant_id: 58775246111052, price_cents: 892 },
    track_pants:               { variant_id: 59185527325004, price_cents: 713 },
    cargo_trousers:            { variant_id: 58775245783372, price_cents: 787 },
    sweatshirt:                { variant_id: 58775246078284, price_cents: 787 },
    cable_knit:                { variant_id: 59185527390540, price_cents: 471 },
    levi_mens_jeans:           { variant_id: 57858624160076, price_cents: 966 },
    wrangler_jeans:            { variant_id: 57858624389452, price_cents: 682 },
    mens_levi_shorts:          { variant_id: 57613827146060, price_cents: 629 },
    levi_lee_wrangler_shorts:  { variant_id: 57788528722252, price_cents: 625 },
    funky_knitwear:            { variant_id: 58679419437388, price_cents: 766 },
    columbia_fleece:           { variant_id: 58775245947212, price_cents: 1050 },
    flannel_shirt:             { variant_id: 59356979396940, price_cents: 619 }
  };
  function variantOf(p) { return VARIANTS[p.id] || { variant_id: 0, price_cents: 0 }; }
  // 10-piece price as checkout charges it: BUNDLE10 takes 5% off each piece,
  // rounded down to the penny.
  function tenPieceCents(listCents) { return listCents - Math.floor(listCents * Math.round(DISCOUNT_PCT * 100) / 100); }

  var PIECES_FALLBACK = [
    { id: 'wax_jacket',     title: "Wax Jacket",     brand: "Mixed Brand", category: "Jackets",     image: "https://cdn.shopify.com/s/files/1/1034/5375/3676/files/unbrandedwaxjacketghostsingle.jpg?v=1791896330", thumb: "https://cdn.shopify.com/s/files/1/1034/5375/3676/files/unbrandedwaxjacketghostsingle.jpg?v=1791896330", resell: "£25-45 resell", stock: "in" },
    { id: 'windbreaker',    title: "Windbreaker",    brand: "Branded",     category: "Jackets",     image: "https://cdn.shopify.com/s/files/1/1034/5375/3676/files/windbreaker_ghost_single_62b10afe-a979-4133-b675-2c4412b9ef03.jpg?v=1789225777", thumb: "https://cdn.shopify.com/s/files/1/1034/5375/3676/files/windbreaker_ghost_single_62b10afe-a979-4133-b675-2c4412b9ef03.jpg?v=1789225777", resell: "£20-30 resell", stock: "in" },
    { id: 'track_pants',    title: "Track Pants",    brand: "Branded",     category: "Trousers",    image: "https://cdn.shopify.com/s/files/1/1034/5375/3676/files/brandedtrackpantsghostsingle_1.jpg?v=1791896312", thumb: "https://cdn.shopify.com/s/files/1/1034/5375/3676/files/brandedtrackpantsghostsingle_1.jpg?v=1791896312", resell: "£15-25 resell", stock: "in" },
    { id: 'cargo_trousers', title: "Cargo Trousers", brand: "Branded",     category: "Trousers",    image: "https://cdn.shopify.com/s/files/1/1034/5375/3676/files/ghost_cargo_trousers_single_82fca80c-a6d5-4c28-90a8-8ce3be1fc4bf.jpg?v=1789225762", thumb: "https://cdn.shopify.com/s/files/1/1034/5375/3676/files/ghost_cargo_trousers_single_82fca80c-a6d5-4c28-90a8-8ce3be1fc4bf.jpg?v=1789225762", resell: "£15-20 resell", stock: "in" },
    { id: 'sweatshirt',     title: "Sweatshirt",     brand: "Branded",     category: "Sweatshirts", image: "https://cdn.shopify.com/s/files/1/1034/5375/3676/files/branded_sweatshrt_ghost_single_ac6dcfe4-c5ba-46e1-8b36-245299ca081b.jpg?v=1789225773", thumb: "https://cdn.shopify.com/s/files/1/1034/5375/3676/files/branded_sweatshrt_ghost_single_ac6dcfe4-c5ba-46e1-8b36-245299ca081b.jpg?v=1789225773", resell: "£15-20 resell", stock: "in" },
    { id: 'cable_knit',     title: "Cable Knit",     brand: "Unbranded",   category: "Knitwear",    image: "https://cdn.shopify.com/s/files/1/1034/5375/3676/files/Cableknitjumpersghostsingle_3686a599-4817-4a97-9083-cf91f0d436d4.jpg?v=1791896345", thumb: "https://cdn.shopify.com/s/files/1/1034/5375/3676/files/Cableknitjumpersghostsingle_3686a599-4817-4a97-9083-cf91f0d436d4.jpg?v=1791896345", resell: "£12-20 resell", stock: "in" },
    { id: 'levi_mens_jeans', title: "Jeans",         brand: "Levi's",      category: "Jeans",       image: "https://cdn.shopify.com/s/files/1/1034/5375/3676/files/Menslevijeansingleghost.jpg?v=1782577671", thumb: "https://cdn.shopify.com/s/files/1/1034/5375/3676/files/Menslevijeansingleghost.jpg?v=1782577671", resell: "£20-25 resell", stock: "in" },
    { id: 'wrangler_jeans', title: "Jeans",          brand: "Wrangler",    category: "Jeans",       image: "https://cdn.shopify.com/s/files/1/1034/5375/3676/files/wranglerjeanssingleeghost.jpg?v=1782577853", thumb: "https://cdn.shopify.com/s/files/1/1034/5375/3676/files/wranglerjeanssingleeghost.jpg?v=1782577853", resell: "£15 resell", stock: "in" },
    { id: 'funky_knitwear',            title: "Knitwear",       brand: "Funky Patterned",     category: "Knitwear", image: "https://cdn.shopify.com/s/files/1/1034/5375/3676/files/funkyknitsingle.jpg?v=1788464404",                  thumb: "https://cdn.shopify.com/s/files/1/1034/5375/3676/files/funkyknitsingle.jpg?v=1788464404",                  resell: "£15-25 resell", stock: "in" },
    { id: 'mens_levi_shorts',          title: "Shorts",         brand: "Levi's",              category: "Shorts",   image: "https://cdn.shopify.com/s/files/1/1034/5375/3676/files/LEVISHORTSsingle.jpg?v=1782496132",                thumb: "https://cdn.shopify.com/s/files/1/1034/5375/3676/files/LEVISHORTSsingle.jpg?v=1782496132",                resell: "£15-20 resell", stock: "in" },
    { id: 'levi_lee_wrangler_shorts',  title: "Shorts",         brand: "Levi/Lee/Wrangler",   category: "Shorts",   image: "https://cdn.shopify.com/s/files/1/1034/5375/3676/files/Womenslevishortsghostsingle.jpg?v=1785959079",       thumb: "https://cdn.shopify.com/s/files/1/1034/5375/3676/files/Womenslevishortsghostsingle.jpg?v=1785959079",       resell: "£15-20 resell", stock: "in" }
  ];

  function loadCart() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      parsed.forEach(function (box) {
        if (!box || !Array.isArray(box.pieces)) return;
        box.pieces.forEach(function (p) {
          var v = variantOf(p);
          p.variant_id = v.variant_id;
          p.price_cents = v.price_cents;
        });
      });
      return parsed;
    } catch (e) { return []; }
  }
  function saveCart(cart) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(cart)); } catch (e) {}
  }
  function clearStoredCart() {
    try { sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
  }

  function init(root) {
    if (root.dataset.byobInit) return;
    root.dataset.byobInit = '1';

    var sectionId = root.dataset.sectionId;
    var dataEl = document.getElementById('byob-data-' + sectionId);
    if (!dataEl) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); }
    catch (e) { console.error('[byob] data parse error', e); return; }

    var mode = data.mode || 'chooser';
    var pieces = Array.isArray(data.pieces) ? data.pieces : [];
    if (pieces.length === 0) {
      console.warn('[byob] Liquid pieces empty — using PIECES_FALLBACK hardcoded list');
      pieces = PIECES_FALLBACK;
    }
    var currency = data.currency || '£';
    var urlChooser = data.urlChooser || '/pages/bundle-builder';
    var url5 = data.url5 || '/pages/bundle-builder-5';
    var url10 = data.url10 || '/pages/bundle-builder-10';

    var box     = root.querySelector('[data-byob-box]');
    var tray    = root.querySelector('[data-byob-tray]');
    var tabs    = root.querySelector('[data-byob-tabs]');
    var grid    = root.querySelector('[data-byob-grid]');
    var meter   = root.querySelector('[data-byob-meter]');
    var clear   = root.querySelector('[data-byob-clear]');
    var cta     = root.querySelector('[data-byob-cta]');
    var ctaLabel  = root.querySelector('[data-byob-cta-label]');
    var elCount   = root.querySelector('[data-byob-count]');
    var elTarget  = root.querySelector('[data-byob-target]');
    var elPrice   = root.querySelector('[data-byob-price]');
    var elKicker  = root.querySelector('[data-byob-kicker]');
    var saveLine  = root.querySelector('[data-byob-save-line]');
    var saveText  = root.querySelector('[data-byob-save-text]');
    var cartbar   = root.querySelector('[data-byob-cartbar]');
    var cartboxes = root.querySelector('[data-byob-cartboxes]');
    var cartdeal  = root.querySelector('[data-byob-cartdeal]');
    var cartsub   = root.querySelector('[data-byob-cartsub]');
    var cartdisc  = root.querySelector('[data-byob-cartdisc]');
    var carttot   = root.querySelector('[data-byob-carttot]');
    var cartCheckout = root.querySelector('[data-byob-cart-checkout]');
    var toast    = root.querySelector('[data-byob-toast]');
    var confetti = root.querySelector('[data-byob-confetti]');

    var initialTarget = mode === 'build_5' ? 5 : (mode === 'build_10' ? 10 : 0);
    var state = {
      mode: mode,
      target: initialTarget,
      pieces: [],
      cart: loadCart(),
      activeTab: 'all'
    };

    var categoryMap = {};
    pieces.forEach(function (p) {
      var c = (p.category || 'Other').trim();
      categoryMap[c] = (categoryMap[c] || 0) + 1;
    });
    var categoryList = ['all'].concat(Object.keys(categoryMap).sort());

    function fmt(n) { return currency + Number(n).toFixed(2); }
    function listPriceOf(p) { return variantOf(p).price_cents / 100; }
    function priceForSize(p, size) {
      var listCents = variantOf(p).price_cents;
      if (size === 10) return tenPieceCents(listCents) / 100;
      return listCents / 100;
    }
    function priceOf(p) { return priceForSize(p, state.target); }
    function subtotalOf(piecesList, sizeOverride) {
      var size = sizeOverride === undefined ? state.target : sizeOverride;
      return piecesList.reduce(function (a, p) { return a + priceForSize(p, size) * (p.qty || 0); }, 0);
    }
    function listSubtotalOf(piecesList) {
      return piecesList.reduce(function (a, p) { return a + listPriceOf(p) * (p.qty || 0); }, 0);
    }
    function qtyOf(piecesList) {
      return piecesList.reduce(function (a, p) { return a + (p.qty || 0); }, 0);
    }
    function savingsForBox(size, pieces) {
      if (size !== 10) return 0;
      return listSubtotalOf(pieces) - subtotalOf(pieces, size);
    }
    function totalForBox(size, sub) { return sub; }
    function currentSub() { return subtotalOf(state.pieces); }
    function currentSavings() { return savingsForBox(state.target, state.pieces); }
    function currentTotal() { return currentSub(); }
    function currentQty() { return qtyOf(state.pieces); }

    function showToast(msg, isWarn) {
      if (!toast) return;
      var icon = isWarn
        ? '<span class="ico"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4"/><path d="M12 16h.01"/></svg></span>'
        : '<span class="ico"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>';
      toast.innerHTML = icon + '<span>' + msg + '</span>';
      toast.hidden = false;
      toast.classList.add('show');
      clearTimeout(toast._t);
      toast._t = setTimeout(function () {
        toast.classList.remove('show');
        setTimeout(function () { toast.hidden = true; }, 250);
      }, 2200);
    }

    function fireConfetti() {
      if (!confetti) return;
      confetti.innerHTML = '';
      confetti.hidden = false;
      var colors = ['#4ADE80', '#15803D', '#fff', '#facc15'];
      for (var i = 0; i < 80; i++) {
        var p = document.createElement('i');
        p.style.left = (Math.random() * 100) + 'vw';
        p.style.background = colors[Math.floor(Math.random() * colors.length)];
        p.style.animationDuration = (2 + Math.random() * 1.8) + 's';
        p.style.animationDelay = (Math.random() * 0.3) + 's';
        p.style.transform = 'rotate(' + (Math.random() * 360) + 'deg)';
        confetti.appendChild(p);
      }
      setTimeout(function () { confetti.hidden = true; confetti.innerHTML = ''; }, 4500);
    }

    function bumpBox() {
      if (!box) return;
      box.classList.remove('is-bump');
      void box.offsetWidth;
      box.classList.add('is-bump');
    }

    function renderBox() {
      if (!tray || !box) return;
      if (state.target <= 0) return;
      var cols = 5;
      var rows = state.target === 5 ? 1 : 2;
      tray.style.gridTemplateColumns = 'repeat(' + cols + ', 1fr)';
      tray.style.gridTemplateRows = 'repeat(' + rows + ', 1fr)';

      var slots = [];
      state.pieces.forEach(function (p) {
        for (var k = 0; k < (p.qty || 0); k++) slots.push(p);
      });

      var html = '';
      for (var i = 0; i < state.target; i++) {
        var p = slots[i];
        if (p) {
          var safeTitle = (p.title || '').replace(/"/g, '&quot;');
          html += '<span class="byob-slot filled">' +
            (p.thumb ? '<img src="' + p.thumb + '" alt="' + safeTitle + '" loading="lazy">' : '') +
            '</span>';
        } else {
          html += '<span class="byob-slot"></span>';
        }
      }
      tray.innerHTML = html;

      var qty = currentQty();
      var sealed = qty === state.target && state.target > 0;
      box.classList.toggle('is-sealed', sealed);
    }

    function renderMeter() {
      if (!meter || state.target <= 0) return;
      var html = '';
      var qty = currentQty();
      for (var i = 0; i < state.target; i++) {
        html += '<span class="byob-pip' + (i < qty ? ' filled' : '') + '"></span>';
      }
      meter.innerHTML = html;
    }

    function renderHeader() {
      if (state.target <= 0) return;
      var qty = currentQty();
      var remaining = state.target - qty;
      var sub = currentSub();
      var savings = currentSavings();
      var total = currentTotal();

      if (elCount)  elCount.textContent  = qty;
      if (elTarget) elTarget.textContent = state.target;
      if (elPrice)  elPrice.textContent  = Number(total).toFixed(2);
      if (elKicker) elKicker.textContent = 'YOUR ' + state.target + '-PIECE BUNDLE';

      if (cta && ctaLabel) {
        if (qty === 0) {
          ctaLabel.textContent = 'Pick ' + state.target + ' pieces';
          cta.disabled = true;
          cta.classList.remove('ready');
        } else if (remaining > 0) {
          ctaLabel.textContent = 'Pick ' + remaining + ' more · ' + fmt(total);
          cta.disabled = true;
          cta.classList.remove('ready');
        } else {
          ctaLabel.textContent = 'Continue to checkout · ' + fmt(total);
          cta.disabled = false;
          cta.classList.add('ready');
        }
      }

      if (saveLine) {
        if (qty > 0 && state.target === 5) {
          if (saveText) saveText.innerHTML = 'Switch to <a href="' + url10 + '" style="color:inherit;text-decoration:underline">10-piece</a> & save ~5% per piece';
          saveLine.hidden = false;
        } else if (qty > 0 && state.target === 10) {
          if (saveText) saveText.innerHTML = '<strong>10-piece pricing applied</strong> — saving ' + fmt(savings) + ' vs 5-piece';
          saveLine.hidden = false;
        } else {
          saveLine.hidden = true;
        }
      }
    }

    function renderTabs() {
      if (!tabs) return;
      var html = '';
      categoryList.forEach(function (c) {
        var label = c === 'all' ? 'All' : c;
        var count = c === 'all' ? pieces.length : (categoryMap[c] || 0);
        html += '<button type="button" class="byob-tab' + (state.activeTab === c ? ' active' : '') +
          '" data-cat="' + c.replace(/"/g, '&quot;') + '" role="tab">' +
          label + '<span class="count">' + count + '</span></button>';
      });
      tabs.innerHTML = html;
    }

    function pieceQty(id) {
      var p = state.pieces.find(function (x) { return x.id === id; });
      return p ? p.qty : 0;
    }

    function renderGrid() {
      if (!grid) return;
      var qty = currentQty();
      var full = qty >= state.target && state.target > 0;

      var filtered = pieces.filter(function (p) {
        return state.activeTab === 'all' || (p.category || 'Other') === state.activeTab;
      });

      if (filtered.length === 0) {
        grid.innerHTML = '<div class="byob-grid-empty">No pieces in this category yet.</div>';
        return;
      }

      var html = '';
      filtered.forEach(function (p) {
        var pq = pieceQty(p.id);
        var soldOut = p.stock === 'out';
        var lowStock = p.stock === 'low';
        var classes = 'byob-piece';
        if (pq > 0) classes += ' has-count';
        if (soldOut) classes += ' is-soldout';

        var safeTitle = (p.title || '').replace(/"/g, '&quot;');
        var imgHtml = p.image
          ? '<img src="' + p.image + '" alt="' + safeTitle + '" loading="lazy">'
          : '<div class="byob-piece-img-placeholder"><svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="m9 9 6 6"/><path d="m15 9-6 6"/></svg></div>';

        var countBadge = (pq > 0 && !soldOut)
          ? '<span class="byob-count-badge">×' + pq + '</span>'
          : '';

        var soldOutTag = soldOut ? '<span class="byob-soldout-tag">Sold out</span>' : '';

        var stockClass = soldOut ? ' out' : (lowStock ? ' low' : '');
        var stockLabel = soldOut ? 'Sold out' : (lowStock ? 'Low stock' : 'In stock');

        var listP = listPriceOf(p);
        var basePriceTen = tenPieceCents(variantOf(p).price_cents) / 100;
        var priceLabel;
        if (state.target === 10) {
          priceLabel = '<div class="byob-piece-price-row">' +
              '<div class="byob-piece-price">' + fmt(basePriceTen) + '</div>' +
              '<span class="byob-piece-was">' + fmt(listP) + '</span>' +
            '</div>' +
            '<div class="byob-piece-savings">5% OFF · 10-PIECE PRICE</div>';
        } else if (state.target === 5) {
          priceLabel = '<div class="byob-piece-price">' + fmt(listP) + '</div>' +
            '<div class="byob-piece-cheaper">' + fmt(basePriceTen) + ' in 10-piece · save 5%</div>';
        } else {
          priceLabel = '<div class="byob-piece-price">' + fmt(priceOf(p)) + '</div>';
        }

        var foot;
        if (soldOut) {
          foot = '<button class="byob-add" disabled>Sold out</button>';
        } else if (pq === 0) {
          foot = '<button class="byob-add" data-add="' + p.id + '"' +
            (full ? ' disabled' : '') +
            '><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 5v14"/><path d="M5 12h14"/></svg>Add</button>';
        } else {
          foot = '<div class="byob-stepper">' +
            '<button data-dec="' + p.id + '" aria-label="Remove one">−</button>' +
            '<span class="qty">' + pq + '</span>' +
            '<button data-inc="' + p.id + '" aria-label="Add another"' + (full ? ' disabled' : '') + '>+</button>' +
            '</div>';
        }

        html += '<div class="' + classes + '">' +
          '<div class="byob-piece-img">' + imgHtml +
            '<span class="byob-piece-cat">' + (p.category || 'Other') + '</span>' +
            countBadge + soldOutTag +
          '</div>' +
          '<div class="byob-piece-body">' +
            (p.brand ? '<div class="byob-piece-brand">' + p.brand + '</div>' : '') +
            '<div class="byob-piece-name">' + (p.title || '') + '</div>' +
            priceLabel +
            (p.resell ? '<div class="byob-piece-resell">↑ ' + p.resell + '</div>' : '') +
            '<div class="byob-piece-stock' + stockClass + '"><span class="dot"></span>' + stockLabel + '</div>' +
            '<div class="byob-piece-foot">' + foot + '</div>' +
          '</div>' +
        '</div>';
      });

      grid.innerHTML = html;
    }

    function renderCartbar() {
      if (!cartbar) return;
      if (state.cart.length === 0) {
        cartbar.hidden = true;
        root.classList.remove('byob-has-cart');
        return;
      }
      cartbar.hidden = false;
      root.classList.add('byob-has-cart');

      var boxesHtml = '';
      state.cart.forEach(function (b, idx) {
        var bSub = subtotalOf(b.pieces, b.size);
        var bListSub = listSubtotalOf(b.pieces);
        var bSavings = b.size === 10 ? bListSub - bSub : 0;

        var thumbs = '';
        var slots = [];
        b.pieces.forEach(function (p) { for (var k = 0; k < p.qty; k++) slots.push(p); });
        for (var i = 0; i < 4; i++) {
          var sp = slots[i];
          if (sp && sp.thumb) {
            thumbs += '<img src="' + sp.thumb + '" alt="" loading="lazy">';
          } else {
            thumbs += '<span></span>';
          }
        }

        var priceHtml = b.size === 10 && bSavings > 0
          ? '<span><s style="opacity:.45">' + fmt(bListSub) + '</s> <strong style="color:#4ade80">' + fmt(bSub) + '</strong></span>'
          : '<span>' + fmt(bSub) + '</span>';

        boxesHtml += '<div class="byob-cartbar-box">' +
          '<div class="byob-cartbar-box-thumbs">' + thumbs + '</div>' +
          '<div class="byob-cartbar-box-info">' +
            '<strong>' + b.size + '-Piece Box</strong>' +
            priceHtml +
          '</div>' +
          '<button class="byob-cartbar-box-x" data-rmbox="' + idx + '" aria-label="Remove box">×</button>' +
        '</div>';
      });
      cartboxes.innerHTML = boxesHtml;

      var grandTotal = 0, grandSavings = 0;
      state.cart.forEach(function (b) {
        var bSub = subtotalOf(b.pieces, b.size);
        grandTotal += bSub;
        if (b.size === 10) {
          grandSavings += listSubtotalOf(b.pieces) - bSub;
        }
      });
      var grandSub = grandTotal + grandSavings;
      var hasTenPiece = state.cart.some(function (b) { return b.size === 10; });

      if (cartdeal) {
        if (hasTenPiece) {
          cartdeal.innerHTML = '<span class="byob-cartbar-deal-on">' +
            '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>' +
            '<strong>10-piece pricing applied</strong> — saving ' + fmt(grandSavings) +
          '</span>';
        } else if (state.cart.length > 0) {
          cartdeal.innerHTML = '<span class="byob-cartbar-deal-nudge">' +
            '<span>Build a <strong>10-piece</strong> & <strong>save ~5%</strong></span>' +
            '<a class="byob-cartbar-add" href="' + url10 + '">+ 10-piece bundle</a>' +
          '</span>';
        } else {
          cartdeal.innerHTML = '';
        }
      }

      if (cartsub) cartsub.textContent = 'Subtotal ' + fmt(grandSub);
      if (cartdisc) {
        if (grandSavings > 0) {
          cartdisc.textContent = '− ' + fmt(grandSavings) + ' · 10-piece pricing';
          cartdisc.hidden = false;
        } else {
          cartdisc.hidden = true;
        }
      }
      if (carttot) carttot.textContent = fmt(grandTotal);
    }

    function renderAll() {
      if (state.target > 0) {
        renderBox();
        renderMeter();
        renderHeader();
        renderGrid();
      }
      renderCartbar();
    }

    function findOrCreate(piece) {
      var existing = state.pieces.find(function (x) { return x.id === piece.id; });
      if (existing) return existing;
      var item = Object.assign({}, piece, { qty: 0 });
      state.pieces.push(item);
      return item;
    }

    function addPiece(id) {
      if (currentQty() >= state.target) {
        showToast('Box is full — seal it!', true);
        return;
      }
      var piece = pieces.find(function (p) { return p.id === id; });
      if (!piece) return;
      if (piece.stock === 'out') return;
      var item = findOrCreate(piece);
      item.qty += 1;
      renderAll();
      bumpBox();
      showToast(piece.title + ' added');
      if (currentQty() === state.target) fireConfetti();
    }

    function decPiece(id) {
      var item = state.pieces.find(function (x) { return x.id === id; });
      if (!item) return;
      item.qty -= 1;
      if (item.qty <= 0) {
        state.pieces = state.pieces.filter(function (x) { return x.id !== id; });
      }
      renderAll();
    }

    function clearPieces() {
      if (state.pieces.length === 0) return;
      state.pieces = [];
      renderAll();
      showToast('Box cleared');
    }

    function snapshotCurrent() {
      return {
        size: state.target,
        pieces: state.pieces.map(function (p) {
          var v = variantOf(p);
          return {
            id: p.id, title: p.title, brand: p.brand, qty: p.qty, thumb: p.thumb,
            variant_id: v.variant_id, price_cents: v.price_cents
          };
        })
      };
    }

    function removeBox(idx) {
      state.cart.splice(idx, 1);
      saveCart(state.cart);
      renderAll();
    }

    async function checkout() {
      var boxes = state.cart.slice();
      if (currentQty() === state.target && state.target > 0) {
        boxes.push(snapshotCurrent());
      }
      if (boxes.length === 0) return;

      var lineMap = {};
      boxes.forEach(function (b) {
        var bundleProp = b.size + '-piece';
        b.pieces.forEach(function (p) {
          var vid = variantOf(p).variant_id || p.variant_id;
          if (!vid) return;
          var key = vid + '|' + bundleProp;
          if (!lineMap[key]) {
            lineMap[key] = {
              id: vid,
              quantity: 0,
              properties: { _BundleSize: bundleProp }
            };
          }
          lineMap[key].quantity += p.qty;
        });
      });
      var items = Object.keys(lineMap).map(function (k) { return lineMap[k]; });
      if (items.length === 0) {
        showToast('Nothing to check out', true);
        return;
      }

      var hasTenPiece = boxes.some(function (b) { return b.size === 10; });

      if (cartCheckout) { cartCheckout.disabled = true; cartCheckout.textContent = 'Adding to cart…'; }
      if (cta) { cta.disabled = true; if (ctaLabel) ctaLabel.textContent = 'Adding to cart…'; }

      try {
        var resp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!resp.ok) {
          var err = await resp.json().catch(function () { return {}; });
          throw new Error(err.description || ('Cart error: ' + resp.status));
        }
        clearStoredCart();
        if (hasTenPiece) {
          window.location.href = '/discount/' + DISCOUNT_CODE + '?redirect=/checkout';
        } else {
          window.location.href = '/checkout';
        }
      } catch (e) {
        console.error('[byob] checkout error', e);
        showToast(e.message || 'Could not add to cart', true);
        if (cartCheckout) {
          cartCheckout.disabled = false;
          cartCheckout.innerHTML = 'CHECKOUT <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
        }
        renderHeader();
      }
    }

    if (clear) clear.addEventListener('click', clearPieces);
    if (cta) cta.addEventListener('click', function () {
      if (cta.disabled) return;
      checkout();
    });
    if (cartCheckout) cartCheckout.addEventListener('click', checkout);

    if (tabs) tabs.addEventListener('click', function (e) {
      var btn = e.target.closest('.byob-tab');
      if (!btn) return;
      state.activeTab = btn.dataset.cat;
      renderTabs();
      renderGrid();
    });

    if (grid) grid.addEventListener('click', function (e) {
      var addBtn = e.target.closest('[data-add]');
      if (addBtn) { addPiece(addBtn.dataset.add); return; }
      var inc = e.target.closest('[data-inc]');
      if (inc) { addPiece(inc.dataset.inc); return; }
      var dec = e.target.closest('[data-dec]');
      if (dec) { decPiece(dec.dataset.dec); return; }
    });

    if (cartbar) cartbar.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-rmbox]');
      if (rm) { removeBox(Number(rm.dataset.rmbox)); return; }
    });

    if (state.target > 0) renderTabs();
    renderAll();
  }

  function injectPricingStyles() {
    if (document.getElementById('byob-pricing-styles')) return;
    var s = document.createElement('style');
    s.id = 'byob-pricing-styles';
    s.textContent = ''
      + '.byob-piece-price-row{display:flex;align-items:baseline;gap:8px;flex-wrap:wrap;}'
      + '.byob-piece-was{font-family:\'Inter\',sans-serif;font-size:13px;font-weight:500;color:rgba(255,255,255,.4);text-decoration:line-through;letter-spacing:-.01em;}'
      + '.byob-piece-cheaper{font-family:\'Inter\',sans-serif;font-size:11px;font-weight:600;color:#4ade80;letter-spacing:.02em;margin:2px 0 4px;line-height:1.3;}'
      + '.byob-piece-savings{display:inline-block;font-family:\'Inter\',sans-serif;font-size:10px;font-weight:800;color:#0a0a0a;background:#4ade80;padding:2px 6px;border-radius:3px;letter-spacing:.06em;margin:4px 0 4px;}'
      + '.byob-piece-brand{color:#4ade80!important;font-weight:700!important;font-size:13px!important;letter-spacing:.04em;text-transform:uppercase;}';
    document.head.appendChild(s);
  }

  function bootAll() {
    injectPricingStyles();
    document.querySelectorAll('[data-byob-section]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootAll);
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var node = e.target && e.target.querySelector('[data-byob-section]');
    if (node) init(node);
  });
})();